import { create } from 'zustand';

interface SyncModalState {
    isOpen: boolean;
    syncError: boolean;
    syncPercentage: number;
    onResume: VoidFunction | null;
    open: (onResume: VoidFunction) => void;
    close: () => void;
    setError: () => void;
    setProgress: (pct: number) => void;
    dismiss: () => void;
}

export const useSyncModalStore = create<SyncModalState>((set) => ({
    isOpen: false,
    syncError: false,
    syncPercentage: 1,
    onResume: null,
    open: (onResume) => set({ isOpen: true, syncError: false, onResume }),
    close: () => set({ isOpen: false, syncError: false, onResume: null }),
    setError: () => set({ syncError: true }),
    setProgress: (pct) => set({ syncPercentage: pct }),
    dismiss: () => set({ isOpen: false, syncError: false, onResume: null }),
}));
